import AppPageRepaymentPlanDetail from 'tio-employee/components/app/page/repayment-plan-detail';

const details = [
  {
    title: 'questions_you_have.repayment_plans.eligible_loan_types',
    description:
      'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.eligible_loan_types',
  },
  {
    title: 'questions_you_have.repayment_plans.years_to_repay',
    description:
      'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.years_to_repay',
  },
  {
    title: 'questions_you_have.repayment_plans.loan_forgiveness',
    description:
      'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.loan_forgiveness',
  },
  {
    title: 'questions_you_have.repayment_plans.monthly_payment',
    description:
      'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.monthly_payment',
  },
];

const pros = [
  'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.pros.pro_1',
  'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.pros.pro_2',
  'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.pros.pro_3',
];

const cons = [
  'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.cons.con_1',
  'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.cons.con_2',
  'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.cons.con_3',
  'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.cons.con_4',
];

const moreSections = [
  {
    title: 'questions_you_have.repayment_plans.keep_in_mind',
    description:
      'questions_you_have.repayment_plans.graduated.graduated_plan.plan_details.keep_in_mind',
  },
];

<template>
  <AppPageRepaymentPlanDetail
    @titleKey="questions_you_have.repayment_plans.graduated.graduated_plan.title"
    @descriptionKey="questions_you_have.repayment_plans.graduated.graduated_plan.description"
    @details={{details}}
    @pros={{pros}}
    @cons={{cons}}
    @moreSections={{moreSections}}
  />
</template>
